import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var AutoAwesomeMosaic = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h8V3H3v18zM21 3h-8v8h8V3zm-8 18h8v-8h-8v8z"
  }));
});
AutoAwesomeMosaic.displayName = 'AutoAwesomeMosaic';
export var AutoAwesomeMosaicDimensions = {
  height: 24,
  width: 24
};